import type { L10nConfigModel } from './l10n-config.model';

export const l10nDefaultConfig: L10nConfigModel = {
    defaultCountryCode: 'US',
    defaultPhoneCode: 1,
    geoCookieName: 'country',
    locales: [
        {
            slug: 'en',
            name: 'English',
            shortName: 'En',
            countries: [],
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'da',
            name: 'Dansk',
            shortName: 'Da',
            registrationAlias: 'en',
            countries: ['DK'],
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'de',
            name: 'Deutsch',
            shortName: 'De',
            countries: ['DE', 'AT', 'CH', 'LI'],
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'es',
            name: 'Español',
            shortName: 'Es',
            countries: [
                'AR',
                'BO',
                'CL',
                'CO',
                'CR',
                'CU',
                'DO',
                'EC',
                'SV',
                'GQ',
                'GT',
                'HN',
                'MX',
                'NI',
                'PA',
                'PY',
                'PE',
                'PR',
                'ES',
                'UY',
                'VE',
            ],
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'fr',
            name: 'Français',
            shortName: 'Fr',
            countries: [
                'BJ',
                'BF',
                'BI',
                'CM',
                'CF',
                'TD',
                'KM',
                'CD',
                'DJ',
                'GQ',
                'FR',
                'GA',
                'GN',
                'HT',
                'CI',
                'LU',
                'MG',
                'ML',
                'MC',
                'NE',
                'CG',
                'RW',
                'SN',
                'SC',
                'TG',
                'VU',
            ],
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'id',
            name: 'Bahasa Indonesia',
            shortName: 'Id',
            countries: ['ID'],
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'it',
            name: 'Italiano',
            shortName: 'It',
            countries: ['IT', 'SM'],
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'ms',
            name: 'Bahasa Melayu',
            shortName: 'Ms',
            countries: ['MY'],
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'nl',
            name: 'Nederlands',
            shortName: 'Nl',
            registrationAlias: 'en',
            countries: ['BE', 'NL'],
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'no',
            name: 'Norsk',
            shortName: 'No',
            countries: ['NO'],
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'pl',
            name: 'Polski',
            shortName: 'Pl',
            countries: ['PL'],
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'pt-br',
            name: 'Português (BR)',
            shortName: 'Pt-br',
            alternateAlias: 'pt-BR',
            registrationAlias: 'pt_BR',
            countries: ['AO', 'BR', 'CV', 'TL', 'GW', 'MZ', 'PT', 'ST'],
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'sv',
            name: 'Svenska',
            shortName: 'Sv',
            countries: ['SE'],
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'ru',
            name: 'Русский',
            shortName: 'Ru',
            countries: ['BY', 'KZ', 'KG', 'RU', 'TM'],
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'ja',
            name: '日本語',
            shortName: '日本語',
            countries: ['JP'],
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'ko',
            name: '한국어',
            shortName: '한국어',
            countries: ['KR'],
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'zh-cn',
            name: '中文 (简体)',
            shortName: '中文 (简体)',
            alternateAlias: 'zh-CN',
            registrationAlias: 'zh_CN',
            countries: [],
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'zh-tw',
            name: '中文 (繁體)',
            shortName: '中文 (繁體)',
            alternateAlias: 'zh-TW',
            registrationAlias: 'zh_TW',
            countries: [],
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'cs',
            name: 'Český',
            shortName: 'Сs',
            countries: [],
            isHiddenFromLocalesList: true,
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'ro',
            name: 'Română',
            shortName: 'Ro',
            countries: [],
            isHiddenFromLocalesList: true,
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'el',
            name: 'Ελληνικά',
            shortName: 'El',
            countries: [],
            isHiddenFromLocalesList: true,
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'et',
            name: 'Eesti',
            shortName: 'Et',
            countries: [],
            isHiddenFromLocalesList: true,
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'hu',
            name: 'Magyar',
            shortName: 'Hu',
            countries: [],
            isHiddenFromLocalesList: true,
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'lt',
            name: 'Lietuvių',
            shortName: 'Lt',
            countries: [],
            isHiddenFromLocalesList: true,
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'tr',
            name: 'Türkiye',
            shortName: 'Tr',
            countries: [],
            isHiddenFromLocalesList: true,
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'fi',
            name: 'Suomi',
            shortName: 'Fi',
            countries: [],
            isHiddenFromLocalesList: true,
            dir: 'ltr',
            url: '',
            level: null,
        },
        {
            slug: 'ar',
            name: 'العربية',
            shortName: 'Ar',
            countries: [],
            isHiddenFromLocalesList: true,
            dir: 'rtl',
            url: '',
            level: null,
        },
        {
            slug: 'he',
            name: 'עברית',
            shortName: 'He',
            countries: [],
            isHiddenFromLocalesList: true,
            dir: 'rtl',
            url: '',
            level: null,
        },
    ],
};
